<template>
    <div class="register">
      <h3>用户注册</h3>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" >
        <el-form-item   prop="userName">
          <el-input v-model="ruleForm.userName" placeholder="请输入用户名称" prefix-icon="el-icon-user-solid" size="medium"></el-input>
        </el-form-item>
        <el-form-item   prop="phoneNumber">
          <el-input v-model="ruleForm.phoneNumber" placeholder="请输入手机号码" prefix-icon="el-icon-phone" size="medium"></el-input>
        </el-form-item>
        <el-form-item   prop="mail">
          <el-input v-model="ruleForm.mail" placeholder="请输入邮箱" prefix-icon="el-icon-message" size="medium"></el-input>
        </el-form-item>
        <el-form-item   prop="company">
          <el-input v-model="ruleForm.company" placeholder="请输入工作单位" prefix-icon="el-icon-postcard" size="medium"></el-input>
        </el-form-item>
        <el-form-item  prop="pass">
          <el-input  type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入登录密码" prefix-icon="el-icon-lock" size="medium" ></el-input>
        </el-form-item>
        <el-form-item  prop="checkPass">
          <el-input v-model="ruleForm.checkPass" placeholder="请再次输入密码" prefix-icon="el-icon-lock" size="medium"></el-input>
        </el-form-item>
        <el-form-item  class="codeItem" prop="checkCode" >
          <el-input
              size="medium"
              v-model.number="ruleForm.checkCode"
              autocomplete="off" maxlength="6"
              class="codeInput"
              oninput="value=value.replace(/[^\d]/g,'')"
              placeholder="验证码"
              prefix-icon="el-icon-s-check"></el-input >
          <el-button type="primary"  @click="getCode" class="codeBtn" :class="{'codeBtnClick':checkCodeLock}" ><span  style="font-size: 14px!important;">获取验证码</span></el-button>
        </el-form-item>
        <div class="error" v-if="error.status">{{error.msg}}</div>
        <el-form-item >
          <el-button class="registBtn" type="primary" @click="submitForm('ruleForm')"><span class="button_text">立即注册</span></el-button>
        </el-form-item>
        <div class="regist"><span>如果您已有账号，请<el-link :underline="false" @click.prevent="$emit('changePage')">立即登录</el-link></span></div>
      </el-form>
    </div>

</template>

<script>
import home from "@/pages/home";
import {Loading, Message} from "element-ui";

export default {
  name: "regist",
  components:{
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value===''){
        this.setError('请输入密码！',callback)
      }else if (this.ruleForm.checkPass!==''){
        this.$refs['ruleForm'].validateField('checkPass');
      }else {
        callback();
      }
    };
    const validateCheckPass = (rule, value, callback) => {
      if (value!==this.ruleForm.pass) {
        this.setError('两次密码输入不一致！',callback);
      }else{
        callback();
      }
    };
    const validateMail = (rule, value, callback) => {
      if (value===''){
        this.setError('请输入邮箱！',callback);
      }else {
        const reg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/
        if(reg.test(value)){
          callback();
        }else {
          this.setError('邮箱格式不正确！',callback);
        }
      }
    };
    const validateCheckCode = (rule, value, callback) => {
      if (value===''){
        this.setError('请输入验证码！',callback);
      }else{
        callback();
      }
    };
    const validateUserName =(rule, value, callback) => {
      if (value===''){
        this.setError('请输入用户名！',callback);
      }else {
        callback();
      }
    };
    const validatePhoneNumber =(rule, value, callback) => {
      if (value===''){
        this.setError('请输入手机号！',callback);
      }else {
        callback();
      }
    };

    return {
      ruleForm: {
        userName: '',
        pass: '',
        checkPass:'',
        mail:'',
        company:'',
        phoneNumber:'',
        checkCode:'',
      },
      rules: {
        pass: [
          { validator: validatePass, trigger: 'blur' },
        ],
        checkPass: [
          { validator:validateCheckPass , trigger: 'blur' },
        ],
        checkCode:[
          { validator:validateCheckCode , trigger: 'blur' },
        ],
        userName: [
          { validator:validateUserName , trigger: 'blur' },
        ],
        phoneNumber: [
          { validator:validatePhoneNumber , trigger: 'blur' },
        ],
        mail: [
          { validator:validateMail , trigger: 'blur' },
        ],
      },
      error:{
        status:true,
        msg:''
      },
      checkCodeLock:false,
      checkCodeTime:0
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const lockScreen = Loading.service({
            lock: true,
            text: '注册中...',
            background: 'rgba(0, 0, 0 ,0.2)'
          });//loading
          const result = await this.$api.checkCheckCode(this.ruleForm.userName, null, this.ruleForm.checkCode);
          if (result) {
            const res = await this.$api.regist(this.ruleForm.userName, this.ruleForm.pass,this.ruleForm.phoneNumber,this.ruleForm.mail,this.ruleForm.company);
            if (res.token) {
              Message({message:'注册成功，已自动登录！', type: "success"});
              localStorage.removeItem('token');
              localStorage.setItem('token', `${res['token_type']} ${res.token}`);
              localStorage.setItem('username', this.ruleForm.userName);
              this.toPage('/navigation');
            } else {//注册失败
              Message({message: res.msg, type: "error"});
            }
          } else {
            this.$set(this.ruleForm, 'checkCode', '');
            this.error.status = true;
            this.error.msg = "验证码输入不正确！"
          }
          lockScreen.close();
        } else {
          this.resetForm(formName);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getCode(){
      this.$refs['ruleForm'].validateField(['userName','phoneNumber'],async (error) => {
        if (error) {
          Message({message: error, type: "error"});
        } else {
          if (this.checkCodeLock) return;
          this.$api.getCheckCode(this.ruleForm.userName,this.ruleForm.phoneNumber);
          this.checkCodeLock = true;
          this.checkCodeTime = 60;
          const timer = await setInterval(() => {
            this.checkCodeTime--;
            if (this.checkCodeTime <= 0) {
              clearInterval(timer);
              this.checkCodeLock = false;
            }
          }, 1000);
        }
      });

    },
    setError(msg,callback){
      this.error.status = true;
      this.error.msg = msg;
      callback(new Error(' '));
    },
    clearError(){
      this.error.status = false;
      this.error.msg = '';
    }
  }
}
</script>

<style scoped>

h3{
  font-family: "微软雅黑 Bold", 微软雅黑, sans-serif;
  font-style: normal;
  font-size: 24px;
  color:rgba(101, 121, 155,.9);
  line-height: 24px;
  text-align: center;
  margin-top: 34px;
  font-weight: bold;
  margin-bottom: 2rem;
}
.regist{
  text-align: right;
  margin-right:-6rem;
  padding-top: .5rem;
}
.el-input{
  padding: 0;
}
.el-button{
  font-family: 微软雅黑, sans-serif;
  font-weight: 500;
  font-style: normal;
  color: rgba(255, 233, 234,.9);
  background: linear-gradient(180deg,rgba(101, 121, 155,.45),rgba(100, 45, 102,.75),rgba(101, 121, 155,.45));
  box-shadow: 0 3px 8px rgba(101, 121, 155,.2);
  border: none;
  margin-left: 14px;
  margin-top: 5px;
}
.el-form-item{
  height: 32px;
}
.el-form-item:first-of-type{
  margin-top: 10px;
}
.el-form-item:last-of-type{
  margin-top: 1px;
  margin-left: -38px;
  padding-left: 0;
}
.register{
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  height: 56.5rem;
  width: 45rem;
  border-radius: 16px;
  background: linear-gradient(to right top,rgba(255,255,255,.76),rgba(255,255,255,.4));
  box-shadow: 0 2px 2px 0 rgba(255, 255, 255, 0.3), 0 5px 5px 0 rgba(255, 255, 255, .2);
  backdrop-filter: blur(2rem);
}
.el-form{
  height: fit-content;
}
.registBtn{
  margin-top: 5px;
  width: 20rem;
  height: 4.3rem;
  background:linear-gradient(135deg,rgba(83, 105, 118,.8),rgba(41, 46, 73,.8));
  box-shadow: 0 2px 3px rgba(83, 105, 118,.4);
  border: none;
  border-radius: 12px;
}
.registBtn:hover{
  color: rgb(105, 195, 207);
  box-shadow: 0 0 8px rgba(101, 121, 155,.9);
}
.button_text{
  font-family: 微软雅黑, sans-serif;
  font-weight: 500;
  font-size: 16px;
  font-style: normal;
  color: rgb(167, 220, 227);
}

.codeItem{
  position: relative;
  display: flex;
}
.codeInput{
  width: 100px;
  position: relative;
  left: -1px;
}
.codeBtn{
  position: relative;
  font-size: 8px;
  width: 90px;
  padding: 10px 9px;
  top: 1px;
  border-radius: 12px;
  right: 2px;
  color: rgba(207, 216, 220,.95);
  background: #425d70;
  border: none;
}
.codeBtn:hover{
  /*background: #425d70;*/
  box-shadow: 0 0 8px rgba(101, 121, 155,.9);
}
.codeBtnClick{
  background: rgba(87, 123, 140,.9);
}
.codeBtnClick:hover{
  box-shadow: none;
  cursor: not-allowed;
}
.error{
  font-size: 13px;
  color: #fe1b52;
  height: fit-content;
  margin-left: 4rem ;
  margin-top: 10px;
  z-index: 999;
}

</style>
